import { computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import { useRoute, useRouter } from 'vue-router';

/**
 * Router helpers with a reactive route `id` param.
 * Must stay reactive: create/update pages reuse the same component when
 * table actions navigate between items.
 */
export const useRouterCustom = (idString = 'id') => {
  const router = useRouter();
  const route = useRoute();

  const id = computed(() => {
    const raw = route.params[idString];
    const numericId = Number(Array.isArray(raw) ? raw[0] : raw);

    return Number.isFinite(numericId) && numericId > 0 ? numericId : 0;
  });

  const goBack = () => {
    router.go(-1);
  };

  const replace = async (to: RouteLocationRaw) => {
    await router.replace(to);
  };

  const push = async (to: RouteLocationRaw) => {
    await router.push(to);
  };

  const searchInUri = (term: string) => {
    const { fullPath } = route;

    return fullPath.includes(term);
  };

  return {
    goBack,
    replace,
    push,
    id,
    searchInUri,
  };
};
